<template>
    <div
        id="export-products-page"
        class="export-products-page"
    >
        <div class="export-products-page__actions">
            <ui5-button
                @click="exportToCsv()"
                :disabled="isExporting"
            >
                <spinner v-if="isExporting" />
                {{ trans('pages.export_products.download_csv') }}
            </ui5-button>
        </div>
        <div class="export-products-page__content">
            <div>
                <ui5-label>
                    {{ trans('pages.export_products.choose_product_type') }}*
                </ui5-label>
                <auto-complete-input
                    v-model="selectedProductType"
                    :options="productTypeOptions"
                    :placeholder="
                        trans('pages.export_products.choose_product_type')
                    "
                    @blur="$v.selectedProductType.$touch"
                />
                <div
                    class="error"
                    :key="selectedProductType + '-error'"
                    v-if="getErrorFromValidator($v.selectedProductType)"
                >
                    {{ getErrorFromValidator($v.selectedProductType) }}
                </div>
            </div>
            <div>
                <ui5-label>
                    {{ trans('pages.export_products.earliest_order_date') }}
                </ui5-label>
                <div>
                    <date-input
                        type="date"
                        v-model="earliestAllowedOrderDateTime"
                        :placeholder="
                            trans('pages.export_products.earliest_order_date')
                        "
                    />
                </div>
            </div>
            <div>
                <ui5-label>
                    {{ trans('pages.export_products.latest_order_date') }}
                </ui5-label>
                <div>
                    <date-input
                        type="date"
                        v-model="latestAllowedOrderDateTime"
                        :placeholder="
                            trans('pages.export_products.latest_order_date')
                        "
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import productApi from '../api/product';
import productTypeApi from '../api/productType';
import AutoCompleteInput from '../components/AutoCompleteInput';
import DateInput from '../components/DateInput';
import Spinner from '../components/loader/Spinner';
import { showErrorMessage, showInfoMessage } from '../dialogs';
import ErrorHelper from '../helpers/ErrorHelper';
import { required } from 'vuelidate/lib/validators';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            isExporting: false,
            selectedProductType: null,
            earliestAllowedOrderDateTime: null,
            latestAllowedOrderDateTime: null,
            productTypes: [],
        };
    },
    computed: {
        productTypeOptions() {
            return this.productTypes.map((productType) => {
                return {
                    value: productType.id,
                    label: productType.externalName,
                };
            });
        },
    },
    methods: {
        fetchProductTypes() {
            productTypeApi.fetchProductTypes().then((response) => {
                this.productTypes = response.data;
            });
        },
        getErrorFromValidator: ErrorHelper.getErrorFromValidator,
        exportToCsv() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                showErrorMessage(
                    this.trans('pages.export_products.fill_required_fields')
                );
                return;
            }

            showInfoMessage(this.trans('pages.export_products.export_started'));

            this.isExporting = true;

            productApi
                .exportByProductType(
                    this.selectedProductType,
                    this.earliestAllowedOrderDateTime,
                    this.latestAllowedOrderDateTime
                )
                .then((response) => {
                    const data = response.data;
                    const filename =
                        response.headers['content-disposition'].split('=')[1];
                    const blob = new Blob([data], {
                        type: response.headers['content-type'],
                    });
                    saveAs(blob, filename);
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.export_products.unknown_export_error')
                    );
                })
                .finally(() => {
                    this.isExporting = false;
                });
        },
    },
    mounted() {
        this.fetchProductTypes();
        // if earliestAllowedOrderDateTime is null, set to start of year
        if (!this.earliestAllowedOrderDateTime) {
            const now = new Date();
            this.earliestAllowedOrderDateTime = new Date(
                now.getFullYear(),
                0,
                1
            ).toISOString();
        }

        // if latestAllowedOrderDateTime is null, set to now
        if (!this.latestAllowedOrderDateTime) {
            this.latestAllowedOrderDateTime = new Date().toISOString();
        }
    },
    components: {
        AutoCompleteInput,
        DateInput,
        Spinner,
    },
    validations() {
        return {
            selectedProductType: {
                required,
            },
        };
    },
};
</script>
